import { render, staticRenderFns } from "./DollarInput.vue?vue&type=template&id=355046a9&scoped=true&"
import script from "./DollarInput.vue?vue&type=script&lang=ts&"
export * from "./DollarInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355046a9",
  null
  
)

export default component.exports